import { DatePicker } from 'antd';
import type { Dayjs } from 'dayjs';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatTaskDateWithWeekday, isTaskDateDisabled } from '../utils/taskDateRule';

interface TaskDatePickerProps {
    value: Dayjs | null;
    onChange: (date: Dayjs | null) => void;
    /** 仓库当前时间，决定哪些日期可选 */
    warehouseNow: Dayjs;
    placeholder: string;
    /** 校验失败提示（如「可选日期已变化」），有值时日期框标红并在下方展示 */
    errorText?: string | null;
}

/**
 * 任务日期选择框：发布确认弹窗（主页面 / 拆分线路）与打印对话框共用。
 * 默认留空，不可选日期置灰，选中后展示「日期 + 星期」（格式跟随后台语言）。
 */
const TaskDatePicker: React.FC<TaskDatePickerProps> = ({
    value,
    onChange,
    warehouseNow,
    placeholder,
    errorText,
}) => {
    const { i18n } = useTranslation();
    const language = i18n.resolvedLanguage || i18n.language;

    return (
        <div>
            <DatePicker
                value={value}
                onChange={(date) => onChange(date ?? null)}
                placeholder={placeholder}
                format={(date: Dayjs) => formatTaskDateWithWeekday(date, language)}
                disabledDate={(current) => isTaskDateDisabled(current, warehouseNow)}
                status={errorText ? 'error' : undefined}
                allowClear={false}
                style={{ width: 220 }}
            />
            {errorText && (
                <div className="text-sm text-red-500 mt-1">{errorText}</div>
            )}
        </div>
    );
};

export default TaskDatePicker;
